import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementTable',
  props: {
    hasPaggination: { type: Boolean },
    pageNum: null,
    pageSize: null,
    pageTotal: null,
    pageSizes: { default: () => [10, 20, 30, 40, 50, 100] },
    hideOnSinglePage: { type: Boolean },
    noMiniHeight: { type: Boolean }
  },
  emits: ["size-change", "current-change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'size-change', value: number),
    (e: 'current-change', value: number)
}), expose: any, slots: any, attrs: any }) {

const props = __props as { hasPaggination?: boolean, pageNum?: number, pageSize?: number, pageTotal?: number, pageSizes: number[], hideOnSinglePage?: boolean, noMiniHeight?: boolean }




function onSizeChange(value: number) {
    emits('size-change', value)
}

function onCurrentChange(value: number) {
    emits('current-change', value)
}

const showPaggination = computed(() => {
    const {
        hasPaggination,
        pageTotal,
        hideOnSinglePage
    } = props
    if (!hasPaggination) {
        return false
    }
    if (hideOnSinglePage && pageTotal !== undefined) {
        return pageTotal > 0 && pageTotal > props.pageSizes?.[0]!
    }
    return true
})

return { __sfc: true,props, emits, onSizeChange, onCurrentChange, showPaggination }
}

})